import Tag from './Tag';

import './tag.scss';

export default Tag;